import { Grid, styled } from "@mui/material";
interface MxCPropertyCheckProps {
  children: any;
  background?: string;
  variant: "top-left" | "top-right" | "bottom-left" | "bottom-right";
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}
const MxCPropertyCheck = (props: MxCPropertyCheckProps) => {
  return <ContentCheck {...props} />;
};

export default MxCPropertyCheck;

const ContentCheck = styled(Grid)<{
  variant: "top-left" | "top-right" | "bottom-left" | "bottom-right";
  background?: string;
}>(({ theme, variant, background }) => ({
  position: "absolute",
  fontWeight: 400,
  color: "white",
  fontSize: 12,
  ...p[variant]
}));

const p = {
  "top-left": {
    top: "0",
    left: "0"
  },
  "top-right": {
    top: "0",
    right: "0"
  },
  "bottom-left": {
    bottom: "0",
    left: "0"
  },
  "bottom-right": {
    bottom: "0",
    right: "0",
    cursor: "pointer"
  }
};
